import { Component, Input, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EarhivInputControlTypes } from '@app/shared/models/earhiv-input-control-types';
import {
  InputControlTypes,
  InputUtils,
  ItemViewProviderDirective,
  Util
} from '@ntap/core';
import { PrimeNGInputDropdownComponent } from '@ntap/primeng';
import { tap } from 'rxjs';

@Component({
  template: ''
})
export abstract class BaseInheritedMetadataInputComponent extends PrimeNGInputDropdownComponent {
  @Input() inheritanceLabel: string = '';

  private itemViewProvider = inject(ItemViewProviderDirective);

  compId: string;
  attrId: number;
  inheritedAttrsFormControlName: string | null;
  formControlInheritable: AbstractControl;

  protected abstract getInheritedControlName(): string;

  override doChangedInputParam(): void {
    const typeName = Util.getFqanTypeName(
      this.inputParam.attributeMetadata.name
    ); // e.g., 'en~jedinica_gradiva'

    this.compId =
      this.inputParam.attributeMetadata.name === `${typeName}~vrsta_medija` ||
      this.inputParam.attributeMetadata.name === `${typeName}~dostupnost`
        ? (InputUtils.compIdByControlType as any)[
            EarhivInputControlTypes.EDITABLE_ITEMLIST
          ]
        : this.inputParam.attributeMetadata.multivalue
        ? InputUtils.compIdByControlType[InputControlTypes.MULTI_SELECT]
        : InputUtils.compIdByControlType[InputControlTypes.DROPDOWN];

    this.attrId = this.inputParam.attributeMetadata.id;
    this.inheritedAttrsFormControlName = this.getInheritedControlName();

    this.initInheritableAttrsFormControl();
    super.doChangedInputParam();
  }

  private initInheritableAttrsFormControl() {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          tap((item: any) => {
            const controlName = this.getInheritedControlName();
            const existingControl =
              this.formService.getFormControl(controlName);

            this.formControlInheritable = existingControl
              ? existingControl
              : this.formService.registerFormControl(
                  controlName,
                  item[controlName]
                );
          })
        )
        .subscribe()
    );
  }
}
